import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';
import TextEditor from '@/components/TextEditor';

import {CommonValue, httpPost, message, pcUrl} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'userInfo': {},
            'courseId': 0,
            'courseInfo': {},
            'info': {
                //报告名称
                'reportName': '',
                //项目背景
                'background': '',
                //项目价值
                'objective': '',
                //理论原理
                'theory': '',
                //制作过程
                'process': '',
                //关联知识
                'conclusion': '',
                //收获展望
                'reference': '',
            },
            'previewInfo': {
                //报告名称
                'reportName': '',
                //项目背景
                'background': '',
                //项目价值
                'objective': '',
                //理论原理
                'theory': '',
                //制作过程
                'process': '',
                //关联知识
                'conclusion': '',
                //收获展望
                'reference': '',
            },
            'lastScrollTop': 0,
            'previewScope': {
                'isFixed': false,
                'top': 0,
                'left': 0,
            },
            'interval' : ""
        };
    }

    componentDidMount() {
        let courseId = this.props.match.params.id;
        if (!courseId)
            this.props.history.goBack();
        this.state.courseId = courseId;
        this.getCourseInfo();
        this.getInfo();

        let userInfo = CommonValue.get('user_info');
        this.setState({
            userInfo
        });

        let previewPosition = $('.report-preview').position();
        this.state.previewScope.top = previewPosition.top;
        this.state.previewScope.left = previewPosition.left;
        this.state.previewScope.width = $('.report-preview').width();

        //$(document).on('scroll',this._onScroll.bind(this));

        this.state.interval = setInterval(() => {
            // console.log("自动保存");
            // this.save();
        }, 60000);
    }

    _onScroll(event) {
        let scrollTop = $(document).scrollTop();
        let previewScope = this.state.previewScope;

        //往下滚动
        if (scrollTop > this.state.lastScrollTop) {
            if (scrollTop >= previewScope.top && !previewScope.isFixed) {
                previewScope.isFixed = true;
                this.setState({previewScope});
            }
        } else {
            if (scrollTop < previewScope.top && previewScope.isFixed) {
                previewScope.isFixed = false;
                this.setState({previewScope});
            }
        }

        this.state.lastScrollTop = scrollTop;
    }

    componentWillUnmount() {
        //$(document).off('scroll',this._onScroll);
    }

    initPreviewInfo() {
        let previewInfo = JSON.parse(JSON.stringify(this.state.info));
        this.setState({previewInfo});
    }

    getCourseInfo() {
        let url = pcUrl('/course/' + this.state.courseId);
        httpPost(url, {}, 'GET')
            .then(data => {
                this.setState({
                    'courseInfo': data,
                });
            });
    }

    getInfo() {
        let url = pcUrl('/study/course/' + this.state.courseId + '/report');
        httpPost(url, {}, 'GET')
            .then(data => {
                this.setState({
                    'info': data,
                }, () => {
                    this.initPreviewInfo();
                });
            });
    }

    save() {
        let url = pcUrl('/study/course/' + this.state.courseId + '/report');
        let param = this.state.info;
        param.status = 0;
        httpPost(url, param)
            .then(() => {
                message('学习报告保存草稿成功', 'success');
            });
    }

    submit() {
        let url = pcUrl('/study/course/' + this.state.courseId + '/report');
        let param = this.state.info;
        param.status = 1;

        if (!param.reportName.length) {
            alert('请输入报告标题');
            $('[name="reportName"]').trigger('focus');
            return false;
        }
        if (param.reportName.length > 50) {
            alert('报告标题不能超过50字');
            $('[name="reportName"]').trigger('focus');
            return false;
        }
        if (!param.background.length) {
            alert('请输入项目背景');
            $('[name="background"]').trigger('focus');
            return false;
        }
        if (!param.objective.length) {
            alert('请输入项目价值');
            $('[name="objective"]').trigger('focus');
            return false;
        }
        if (!param.theory.length) {
            alert('请输入理论原理');
            $('[name="theory"]').trigger('focus');
            return false;
        }
        if (!param.process.length) {
            alert('请输入制作过程');
            $('[name="process"]').trigger('focus');
            return false;
        }
        if (!param.conclusion.length) {
            alert('请输入关联知识');
            $('[name="conclusion"]').trigger('focus');
            return false;
        }
        if (!param.reference.length) {
            alert('请输入收获展望');
            $('[name="reference"]').trigger('focus');
            return false;
        }

        if (window.confirm('确认所填写报告正确无误，需要提交吗?')) {
            httpPost(url, param)
                .then(() => {
                    alert('学习报告提交成功，请等待审核');
                    clearInterval(this.state.interval);
                    this.props.history.push('/user/index');
                });
        }
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="report-add-panel">
                        <div className="captain">
                            <h3>
                                撰写报告
                            </h3>
                            <h4>
                                {this.state.courseInfo.name}
                            </h4>
                        </div>
                        <div className="panel-body">
                            <div className="report-left">
                                <div className="report-left-1">
                                    <div className="form compact">
                                        <div className="form-li">
                                            <span className="label">报告标题：</span>
                                            <input name="reportName" value={this.state.info.reportName}
                                                   onChange={e => this.bindModel(e)}
                                                   onBlur={() => this.initPreviewInfo()} className="input-text"/>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-li">
                                                    <span className="label">姓名：</span>
                                                    <span className="value"> {this.state.userInfo.name} </span>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-li">
                                                    <span className="label">导师姓名：</span>
                                                    <span className="value"> {this.state.courseInfo.teacherName} </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-li">
                                                    <span className="label">所在学校：</span>
                                                    <span className="value"> {this.state.userInfo.schoolName} </span>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-li">
                                                    <span className="label">导师学校：</span>
                                                    <span
                                                        className="value"> {this.state.courseInfo.teacherSchool} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="report-left-2">
                                    <div className="form">
                                        <div className="form-li big">
                                            <span className="label">项目背景</span>
                                            <div
                                                className={["form-value", this.state.info.background && this.state.info.background.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="200px" name="background"
                                                         value={this.state.info.background}
                                                         onChange={val => this.changeInfo('background', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.background ? this.state.info.background.length : 0}/200字
											</div>
											*/}
                                            </div>
                                            {/*
										<div className={["form-value",this.state.info.background.length > 200?'error':''].join(' ')}>
											<textarea name="background" value={this.state.info.background} onChange={e=>this.bindModel(e)} onBlur={()=>this.initPreviewInfo()} className="input-textarea" rows="3"></textarea>
											<br/>
											<div className="desc">
												{this.state.info.background.length}/200字
											</div>
										</div>
										*/}
                                        </div>
                                        <div className="form-li big">
                                            <span className="label">项目价值</span>
                                            <div
                                                className={["form-value", this.state.info.objective && this.state.info.objective.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="200px" name="objective"
                                                         value={this.state.info.objective}
                                                         onChange={val => this.changeInfo('objective', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                {/*
											<textarea name="objective" value={this.state.info.objective} onChange={e=>this.bindModel(e)} onBlur={()=>this.initPreviewInfo()} className="input-textarea" rows="3"></textarea>
											*/}
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.objective? this.state.info.objective.length:0}/200字
											</div>
											*/}
                                            </div>
                                        </div>
                                        <div className="form-li big">
                                            <span className="label">理论原理</span>
                                            <div
                                                className={["form-value", this.state.info.theory && this.state.info.theory.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="400px" name="theory"
                                                         value={this.state.info.theory}
                                                         onChange={val => this.changeInfo('theory', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.theory?this.state.info.theory.length:0}/200字
											</div>
											*/}
                                            </div>
                                        </div>
                                        <div className="form-li big">
                                            <span className="label">制作过程</span>
                                            <div
                                                className={["form-value", this.state.info.process && this.state.info.process.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="400px" name="process"
                                                         value={this.state.info.process}
                                                         onChange={val => this.changeInfo('process', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.process?this.state.info.process.length:0}/200字
											</div>
											*/}
                                            </div>
                                        </div>
                                        <div className="form-li big">
                                            <span className="label">关联知识</span>
                                            <div
                                                className={["form-value", this.state.info.conclusion && this.state.info.conclusion.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="400px" name="conclusion"
                                                         value={this.state.info.conclusion}
                                                         onChange={val => this.changeInfo('conclusion', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.conclusion?this.state.info.conclusion.length:0}/200字
											</div>
											*/}
                                            </div>
                                            {/*
										<textarea name="reportName" value={this.state.info.reportName} onChange={e=>this.bindModel(e)} onBlur={()=>this.initPreviewInfo()} className="input-textarea" rows="9"></textarea>
										*/}
                                        </div>
                                        <div className="form-li big">
                                            <span className="label">收获展望</span>
                                            <div
                                                className={["form-value", this.state.info.reference && this.state.info.reference.length > 200 ? 'error' : ''].join(' ')}>
                                                <TextEditor width="100%" height="200px" name="reference"
                                                         value={this.state.info.reference}
                                                         onChange={val => this.changeInfo('reference', val)}
                                                         onBlur={() => this.initPreviewInfo()}/>
                                                <br/>
                                                {/*
											<div className="desc">
												{this.state.info.reference?this.state.info.reference.length:0}/200字
											</div>
											*/}
                                            </div>
                                        </div>
                                        <div className="form-submit">
                                            <button className="button button-gray" onClick={() => this.save()}>保存草稿
                                            </button>
                                            <button className="button button-blue" onClick={() => this.submit()}>提 交
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="report-right">
                                <div className="report-preview" style={this.state.previewScope.isFixed ? {
                                    'position': 'fixed',
                                    'top': 10,
                                    'left': this.state.previewScope.left,
                                    'width': this.state.previewScope.width
                                } : {}}>
                                    <h3>预览</h3>
                                    <div className="report-preview-inner">
                                        <div className="preview-inner">
                                            <div className="preview-inner-inner">
                                                <div className="inner-title">
                                                    {this.state.previewInfo.reportName}
                                                </div>
                                                {this.state.previewInfo.reportName && this.state.previewInfo.reportName.length > 0 && (
                                                    <div className="inner-desc">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span>学生姓名：</span>
                                                                {this.state.userInfo.name}
                                                            </div>
                                                            <div className="col-6">
                                                                <span>导师姓名：</span>
                                                                {this.state.courseInfo.teacherName}
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span>所在学校：</span>
                                                                {this.state.userInfo.schoolName}
                                                            </div>
                                                            <div className="col-6">
                                                                <span>导师学校：</span>
                                                                {this.state.courseInfo.teacherSchool}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.background.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            项目背景
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.background}}></div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.objective.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            项目价值
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.objective}}></div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.theory.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            理论原理
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.theory}}></div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.process.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            制作过程
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.process}}></div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.conclusion.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            关联知识
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.conclusion}}></div>
                                                    </div>
                                                )}
                                                {this.state.previewInfo.reference.length > 0 && (
                                                    <div className="inner-panel">
                                                        <div className="inner-captain">
                                                            收获展望
                                                        </div>
                                                        <div className="inner-body"
                                                             dangerouslySetInnerHTML={{'__html': this.state.previewInfo.reference}}></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="clear"></div>
                        </div>
                        <div className="help-box">
                            <div className="help">
                                <div>报告不会写？</div>
                                <div>可以点这里<a className="text-blue1" href="javascript:;"
                                             onClick={() => window.open('/studyGuide', '_blank')}>学习一下</a>，
                                </div>
                                <div>也可以点击<a className="text-blue1"
                                             href={"https://vod.jscqe.com/" + this.state.courseInfo.reportTemplateUrl}
                                             target="_blank">下载参考报告 </a>！
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
